import { render, staticRenderFns } from "./dlt.vue?vue&type=template&id=6640bacf&scoped=true"
import script from "./dlt.vue?vue&type=script&lang=js"
export * from "./dlt.vue?vue&type=script&lang=js"
import style0 from "./dlt.vue?vue&type=style&index=0&id=6640bacf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6640bacf",
  null
  
)

export default component.exports